import $ from 'jquery';

export default function categoryFilter() {
  
  function init() {
    $('#category-filter .btn-cta').on('click', function(e) {
			e.preventDefault();
      //filtro esperienza selezionato
      var category = $(this).data("filter");
      //attivo il bottone selezionato
			$('#category-filter .btn-cta').removeClass("active");
			$(this).addClass('active');
      
      if($('#results').length > 0) {
        $('#results .all').parent('div[class*="col"]').addClass('d-none');
        $('#results .esperienza.'+category).parent('div[class*="col"]').removeClass('d-none');
      }
		});
  }
  
  $( document ).ready(function() {
    if($('#category-filter').length > 0) {
      init();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/category-filter.js